export const FETCH_RULES_SUCCESS = 'FETCH_RULES_SUCCESS';
export const FETCH_RULE_SUCCESS = 'FETCH_RULE_SUCCESS';
export const FETCHING_RULES = 'FETCHING_RULES';
export const FETCHING_RULE = 'FETCHING_RULE';
export const BACKUP_RULES = 'BACKUP_RULES';
export const RESTORE_RULES = 'RESTORE_RULES';
export const UPDATE_SELECTED_RULES_SUCCESS = 'UPDATE_SELECTED_RULES_SUCCESS';
export const ADD_ORDERED_RULES = 'ADD_ORDERED_RULES';
export const RE_ORDER_RULES_SUCCESS = 'RE_ORDER_RULES_SUCCESS';
export const REMOVE_ORDERED_RULE = 'REMOVE_ORDERED_RULE';
export const VALIDATE_RULE_SUCCESS = 'VALIDATE_RULE_SUCCESS';
export const VALIDATE_RULE_ERROR = 'VALIDATE_RULE_ERROR';
export const VALIDATING_RULE = 'VALIDATING_RULE';
export const VALIDATE_RULE_RESET = 'VALIDATE_RULE_RESET';
export const FETCH_SUBTYPES_SUCCESS = 'FETCH_SUBTYPES_SUCCESS';
export const CREATE_RULE_SUCCESS = 'CREATE_RULE_SUCCESS';
export const CREATING_RULE = 'CREATING_RULE';
export const RESET_RULE_CREATOR = 'RESET_RULE_CREATOR';
export const RULES_SUBTYPES_ORDER = ['VALIDATION-PRE', 'ENRICHMENT-PRE', 'IGNORED-PRE', 'ALLOCATION-PRE','VALIDATION-POST', 'ENRICHMENT-POST', 'IGNORED-POST', 'POSTED'];
export const APPLYING_ALLOCATION_RULE = 'APPLYING_ALLOCATION_RULE';
export const APPLY_ALLOCATION_SUCCESS  = 'APPLY_ALLOCATION_SUCCESS';



// WEBPACK FOOTER //
// ./src/redux/rules/RulesConstants.js